import { render, staticRenderFns } from "./DataText.vue?vue&type=template&id=58abccd3&scoped=true"
import script from "./DataText.vue?vue&type=script&lang=js"
export * from "./DataText.vue?vue&type=script&lang=js"
import style0 from "./DataText.vue?vue&type=style&index=0&id=58abccd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58abccd3",
  null
  
)

export default component.exports